import * as AT from './actionTypes'

export type ChangePasswordActionType = {
  type: typeof AT.SUBMIT
}

const submit = (): ChangePasswordActionType => ({
  type: AT.SUBMIT
})

export default { submit }
